import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//location add
export const addLocationData = createAsyncThunk(
  "location/addlocation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/locations", //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//location options
export const getLocationOptions = createAsyncThunk(
  "locations/getoptions",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/locations`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// locations chart
export const getLocationChart = createAsyncThunk(
  "locations/getchart",
  async (data, { rejectWithValue }) => {
    const { search_text, location_id, ...rest } = data;
    const queryString = new URLSearchParams({
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/locations/chart?${queryString}`, //endpoint
        //data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//delete unit
export const deleteLocation = createAsyncThunk(
  "locations/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/locations/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//update location details
export const updateLocations = createAsyncThunk(
  "locations/updatelocations",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/locations/${id}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
//get location by id
export const locationByid = createAsyncThunk(
  "locations/locationByid",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/locations/${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
